import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMapWidgetQuery } from '../../redux/config/chart-data';
import type { WidgetConfigurationData } from '../../redux/config/widgetApi';
import { getWidgets } from '../../redux/slices/layout-tabs-slice';
import ChartGenericWrapper from '../common/chart-generic-wrapper';
import MapWidget from '../Map/map-component';
import type { ChartProps } from './chart.interface';
import useInvalidateChartResponse from './hooks/useInvalidateChartResponse';
import useStartEndDates from './hooks/useStartEndDates';

export default function OdinMapWidget({ widgetId, layoutProps }: ChartProps) {
  const [configurationData, setConfigurationData] = useState<WidgetConfigurationData>();

  const { startDate, endDate } = useStartEndDates();
  const widgets = useSelector(getWidgets);

  const {
    data: widgetChartData,
    isLoading: isWidgetChartDataLoading,
    isFetching: isWidgetChartDataFetching,
    isError,
    error,
  } = useMapWidgetQuery({
    widgetId,
    from: startDate,
    to: endDate,
  });

  const handleRefetch = useInvalidateChartResponse(widgetId);

  useEffect(() => {
    if (widgets) {
      setConfigurationData(widgets.find((widget) => +widget.widget.id === +widgetId)?.widget);
    }
  }, [widgets, widgetId]);

  return (
    <ChartGenericWrapper
      widgetId={widgetId}
      isFetching={isWidgetChartDataFetching}
      isLoading={isWidgetChartDataLoading}
      isError={isError}
      error={error}
      refetch={handleRefetch}
      widgetChartData={widgetChartData}
      widgetConfigurationData={configurationData && { ...configurationData, layoutProps }}
      renderNoDataByDefault={!isWidgetChartDataFetching && !widgetChartData?.length}
    >
      {configurationData && widgetChartData && (
        <MapWidget data={widgetChartData} widgetId={widgetId} configurationData={configurationData} />
      )}
    </ChartGenericWrapper>
  );
}
